export const ListAndDetailSamplesFiltersPageInfo = () => {
  return (
    <>
        This example shows how you can filter a list. <br />
        Click on the filter icon next to the search icon to filter the list by Countries and Population Size.
    </>
  )
}
